import styled from 'styled-components'
import { Grid } from 'components/grid'
import { pulsate } from 'components/link'

export const Users = styled(Grid)`
    grid-auto-flow: row;
    grid-auto-rows: auto;
    gap: 24px;
`

export const User = styled(Grid)`
    grid-template-columns: minmax(0, 1fr) 40px;
    align-items: center;
    gap: 16px;

    &.pending {
        animation: ${pulsate} 1s ease-in-out infinite;
        pointer-events: none;
    }
`